import React from "react";
import { data } from "../data";
import Pic from "../assets/IMG_0540.JPG";
import ProfilePic from "../assets/danholbrook.JPG";
import {
  Page,
  Section,
  Heading,
  ImageBox,
  Image,
  PageContentWrapWithSideBar,
  Text,
  HeroBlurb,
  Button,
  Box
} from "../theme";
import { Accordian } from "../Components/Accordian/Accordian";
const { Attorneys } = data;

export const Profile = props => {
  const attorney = Attorneys["ronHill"];
  return (
    <Page>
      <ImageBox width={1} bgImage={Pic}>
        <Box
          position="absolute"
          filter={"brightness(1.4)"}
          bg="primary"
          height="100%"
          width={1}
          zIndex="1"
          mixBlendMode="soft-light"
        />
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          alignItems="center"
          width={1}
          height="100%"
          bg="rgba(33,33,33,.6)"
          py={4}
        >
          <Image
            mx="auto"
            borderRadius="100%"
            src={ProfilePic}
            width={180}
            zIndex="2"
            filter="saturate(.1)"
          />
          <Heading
            textAlign="center"
            color="white"
            width={1}
            fontSize={3}
            mt={3}
            zIndex="2"
          >
            Dan Holbrook
          </Heading>
        </Box>
      </ImageBox>
      <PageContentWrapWithSideBar bg="secondaryLight" pb={5}>
        <Box width={2 / 3} pt={5} display="flex" alignItems="center">
          <Accordian />
        </Box>
      </PageContentWrapWithSideBar>
    </Page>
  );
};
export default Profile;
